import React, { useEffect, useState } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { FETCH_LIST } from 'Config';
import ReactTable from 'Components/ReactTable/ReactTable';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import {
    Select as SELECT_DEMAT,
    SelectByID
} from 'Components/Api/DematGrowthLossAPI';
import { Insert as ADD } from 'Components/Api/DematGrowthLossAPI';
import { Update as UPDATE } from 'Components/Api/DematGrowthLossAPI';
import { MaterialDatePickerField } from 'Components/Inputes/MaterialDatePickerField';
import { Delete as DELETE } from 'Components/Api/DematGrowthLossAPI';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { ConfirmAlert } from 'Components/Alert/ConfirmAlert';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { Container, Grid, Paper, MenuItem } from '@material-ui/core';
import { SelectUserForDropDown as USER_SELECT_FOR_DROPDOWN } from 'Components/Api/UsersApi';
import InputLabel from 'Components/Inputes/InputLabel';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';

import { SelectSubscriptionAllowedServices as SERVICE_SELECT_ALL } from 'Components/Api/ServiceApi';
import { Select as SELECT_PLAN } from 'Components/Api/ServiceSubscriptionPlanMasterAPI';
import { LOGOUT } from 'ConstComponents';
import HOCLoader from 'Components/Loader/HOCLoader';
import CircularProgress from '@material-ui/core/CircularProgress';
import AsyncAutoComplete from 'Components/Inputes/AsyncAutoComplete';
import { PLEASE_SELECT_VALID } from 'Components/Helper/Messages';
const CustomContainer = HOCLoader(Container);

export const DematGrowthLoss = () => {
    const classes = commonStyle();
    const [downline, setDownline] = useState([]);
    const [loadingOpen, setLoadingOpen] = useState(false);

    const [isError, setIsError] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [severity, setSeverity] = useState('success');
    const [mainColumns, setMainColumns] = useState([]);
    const [Services, setServices] = useState([]);
    const [Data, setData] = useState([]);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [isUpdate, setIsUpdate] = useState(false);
    const [plans, setPlan] = useState([]);
    const [IsFetchAllList, setisFetchAllList] = useState(false);
    const [UserInfo, setUserInfo] = useState('');
    const [userDefault, setUserDefault] = useState({
        UserID: 0,
        FirmName: 'Select User'
    });
    const [formObj, setFormObject] = useState({
        DematGrowthLossMasterID: 0,
        UserID: 0,
        ServiceID: '0',
        Amount: '',
        ServiceStatus: 'Growth',
        Plan: '',
        ServiceSubscriptionPlanMasterID: 0,
        User: userDefault,
        ManualDate: new Date()
    });

    const Delete = async (requestObj) => {
        setLoadingOpen(true);
        var reqObj = JSON.stringify(requestObj);
        var response = await DELETE(reqObj);
        setLoadingOpen(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);

        setIsError(true);
        setSeverity('success');
        setResponseMessage(data);

        select();
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        if (loadingOpen) {
            return;
        }

        values.UserID = values.User.UserID;

        var requestObj = JSON.stringify(values);

        setLoadingOpen(true);
        setIsError(false);

        var response = isUpdate
            ? await UPDATE(requestObj)
            : await ADD(requestObj);

        setLoadingOpen(false);
        setSubmitting(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        setResponseMessage(response.data);
        setIsError(true);
        setSeverity('success');

        select();
        resetForm(formObj);
    };

    const onDeleteClick = (item) => {
        var RequestObj = { DematGrowthLossMasterID: item };
        setIsAlertOpen(true);
        setConfirmAlertRequest(RequestObj);
    };

    const createColumns = () => {
        var columns = [];
        columns.push({
            label: '#',
            name: 'DematGrowthLossMasterID',
            srno: true
        });
        columns.push({
            label: 'Date',
            name: 'DOC'
        });

        columns.push({
            label: 'User',
            name: 'FirmName'
        });

        columns.push({
            label: 'Service',
            name: 'ServiceName'
        });

        columns.push({
            label: 'Amount',
            name: 'Amount'
        });

        columns.push({
            label: 'Service Status',
            name: 'GrowthLoss'
        });

        columns.push({
            label: 'Plan',
            name: 'Plan'
        });

        columns.push({
            label: 'Edit',
            name: 'DematGrowthLossMasterID',
            buttonTitle: 'Edit',
            update: true,
            callback: (value) => {
                Edit(value[0]);
            }
        });

        columns.push({
            label: 'Delete',
            name: 'DematGrowthLossMasterID',
            delete: true,
            callback: (value) => {
                onDeleteClick(value);
            }
        });

        setMainColumns(columns);
    };
    useEffect(() => {
        createColumns();
        selectServices();
        select();
        selectPlan();
        fetchUserList();
    }, []);

    const fetchUserList = async () => {
        let listValue = await FETCH_LIST();

        if (listValue === undefined || listValue === null || listValue === '') {
            return;
        }

        if (listValue !== undefined && listValue === 'All') {
            setisFetchAllList(true);
            SelectUser('');
            return;
        }
    };

    const callSearch = async (text) => {
        if (
            text === undefined ||
            text === null ||
            text === '' ||
            //  text.length <= 0 ||
            text === userDefault.FirmName
        )
            return;

        var jsonObj = {
            FirmName: text
        };
        SelectUser(jsonObj);
    };

    const SelectUser = async (values) => {
        setLoadingOpen(true);
        var request = JSON.stringify(values);
        setLoadingOpen(false);
        const userResponse = await USER_SELECT_FOR_DROPDOWN(request);

        if (!userResponse.isAuthorized) LOGOUT();

        if (!userResponse.status) {
            setIsError(true);
            setSeverity('error');
            return;
        }
        var data = JSON.parse(userResponse.data);

        let objWithSelectAll = [userDefault, ...data];
        setDownline(objWithSelectAll);
    };
    const updateUserID = async (value, setFieldValue) => {
        setFieldValue('UserID', value.UserID);
        setUserDefault({
            UserID: value.UserID,
            FirmName: value.FirmName
        });
    };

    const select = async () => {
        const response = await SELECT_DEMAT();

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }
        setSeverity('success');
        var data = JSON.parse(response.data);

        setData(data);
    };
    const selectPlan = async () => {
        const response = await SELECT_PLAN();
        if (!response.isAuthorized) LOGOUT();

        var data = JSON.parse(response.data);
        setPlan(data);
    };
    const selectServices = async () => {
        const response = await SERVICE_SELECT_ALL();
        if (!response.isAuthorized) LOGOUT();

        var data = JSON.parse(response.data);
        setServices(data);
    };
    const FormValidationSchema = Yup.object({
        User: Yup.object()
            .nullable(PLEASE_SELECT_VALID + 'User')
            .required(PLEASE_SELECT_VALID + 'User')
            .shape({
                UserID: Yup.string()
                    .notOneOf(['0'], PLEASE_SELECT_VALID + 'User')
                    .required(PLEASE_SELECT_VALID + 'User')
            }),

        ServiceSubscriptionPlanMasterID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'plan')
            .required(PLEASE_SELECT_VALID + 'plan'),

        ServiceID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'service')
            .required(PLEASE_SELECT_VALID + 'service'),

        Amount: Yup.number()
            .required(PLEASE_SELECT_VALID + ' amount')
            .min(0, PLEASE_SELECT_VALID + ' amount'),
        ManualDate: Yup.date()
            .nullable(PLEASE_SELECT_VALID + 'from date')
            .required(PLEASE_SELECT_VALID + 'date')
            .max(new Date(), PLEASE_SELECT_VALID + 'from date')
            .typeError(PLEASE_SELECT_VALID + 'from date')
    });

    const Edit = (DematGrowthLossMasterID) => {
        setIsUpdate(true);
        selectByID(DematGrowthLossMasterID);
    };

    const selectByID = async (DematGrowthLossMasterID) => {
        let JSONObj = {
            DematGrowthLossMasterID: DematGrowthLossMasterID
        };

        var request = JSON.stringify(JSONObj);

        setLoadingOpen(true);
        const response = await SelectByID(request);
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        var data = JSON.parse(response.data);
        setIsUpdate(true);
        setUserDefault({
            UserID: data.UserID,
            FirmName: data.FirmName
        });

        setFormObject({
            DematGrowthLossMasterID: data.DematGrowthLossMasterID,
            Amount: data.Amount,
            ServiceStatus: data.GrowthLoss,
            ServiceID: data.ServiceID,
            Plan: data.Plan,
            ServiceSubscriptionPlanMasterID:
                data.ServiceSubscriptionPlanMasterID,
            ManualDate: data.ManualDate,
            User: {
                UserID: data.UserID,
                FirmName: data.FirmName
            }
        });
    };
    const ProviderAddForm = ({ setFieldValue }) => {
        return (
            <Form>
                {' '}
                <h2 className={classes.PaperHead_h2}>Growth Loss Analysis</h2>
                <Grid item xs={12}>
                    <Paper className={classes.PaperStyle}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <Field
                                    component={AsyncAutoComplete}
                                    defaultValue={userDefault}
                                    FieldName="User"
                                    name="User"
                                    SubFieldName="UserID"
                                    options={downline}
                                    getOptionLabel={(option) => option.FirmName}
                                    textFieldProps={{
                                        label: 'Select User'
                                    }}
                                    onSearchCallback={(text) => {
                                        callSearch(text);
                                    }}
                                    onCustomCallback={(name, value) => {
                                        updateUserID(value, setFieldValue);
                                    }}
                                />
                                <InputLabel color="green" value={UserInfo} />
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialSelect
                                    label="Service"
                                    name="ServiceID"
                                    title="Service"
                                >
                                    <MenuItem key="0" value="0">
                                        All Service
                                    </MenuItem>
                                    {Services.map((Item) => (
                                        <MenuItem
                                            key={Item.ServiceID}
                                            value={Item.ServiceID}
                                        >
                                            {Item.ServiceName}
                                        </MenuItem>
                                    ))}
                                </MaterialSelect>
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialSelect
                                    label="Service Status"
                                    name="ServiceStatus"
                                    title="Service Status"
                                >
                                    <MenuItem key="Growth" value="Growth">
                                        Growth
                                    </MenuItem>
                                    <MenuItem key="Loss" value="Loss">
                                        Loss
                                    </MenuItem>
                                </MaterialSelect>
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialSelect
                                    label="Select Plan"
                                    name="ServiceSubscriptionPlanMasterID"
                                >
                                    <MenuItem key="0" value="0">
                                        Select Plan
                                    </MenuItem>
                                    {plans.map((Item) => (
                                        <MenuItem
                                            key={
                                                Item.ServiceSubscriptionPlanMasterID
                                            }
                                            value={
                                                Item.ServiceSubscriptionPlanMasterID
                                            }
                                        >
                                            {Item.PlanName}
                                        </MenuItem>
                                    ))}
                                </MaterialSelect>
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialNumberField
                                    label="Amount"
                                    name="Amount"
                                    type="text"
                                    length={7}
                                    placeholder="Amount"
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialDatePickerField
                                    name="ManualDate"
                                    label="Growth/Loss Date"
                                    maxDate={new Date()}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <PrimaryButton
                                    type="submit"
                                    title={isUpdate ? 'Update' : 'Add'}
                                    className={classes.CustomPrimaryButtonStyle}
                                    disabled={loadingOpen}
                                >
                                    {isUpdate ? 'Update' : 'Add'}
                                </PrimaryButton>
                                {loadingOpen && (
                                    <CircularProgress
                                        size={24}
                                        className={classes.buttonProgress}
                                    />
                                )}
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <SecondaryButton
                                    type="reset"
                                    title="Reset"
                                    className={classes.CustomDangerButtonStyle}
                                >
                                    Reset
                                </SecondaryButton>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Form>
        );
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObj}
                validationSchema={FormValidationSchema}
                onSubmit={handleSubmit}
                resetForm={formObj}
            >
                {ProviderAddForm}
            </Formik>
            {isAlertOpen && (
                <ConfirmAlert
                    isOpen={isAlertOpen}
                    title="Delete Confirmation"
                    message="Are you sure to delete Demat Growth Loss details?"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        Delete(request);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            )}

            <h2 className={classes.PaperHead_h2}>Demat Growth Loss List</h2>
            <ReactTable data={Data} columns={mainColumns} rowsPerPage={100} />
        </CustomContainer>
    );
};
